import UI from "./UI";
import {gsap, Power0} from 'gsap';
import {scrollTo, preventScroll} from "../../functions/simple.ui";
import {
    isA11yCheckVersion,
    a11yHideOtherContent,
    a11yShowOtherContent,
    isA11ySetAttr,
    a11yDebounce,
    a11yAcessFocus,
    isA11yButtonRole,
    isA11ySwiperSpinnerUpdate,
    isA11ySwiperPopupUpdate,
    FocusTrap,
} from "../../functions/a11y.ui";

/**
* 1팝업류의 추상클래스이다. PopupAlert, PopupCalendar, PopupExternal, PopupSelect, PopupTooltip의  공통이 정의되어있다.
* @example 
* 
* static functions
*
*
* // 어떤종류의 팝업이던지 화면이 보이는지/안보이는지
*  frontUI.Popup.isOpenPopup()
* 
*  // 풀팝업 화면에 보이는지/안보이는지
*  frontUI.Popup.isOpenFullPopup()
* 
*  // 앨럿이 화면에 보이는지/안보이는지
*  frontUI.Popup.isOpenAlertPopup()
* 
*  // 반팝업이 화면에 보이는지/안보이는지
*  frontUI.Popup.isOpenBottomPopup()
* 
*  // 반팝업 모두 닫기
*  frontUI.Popup.closeAllBottomPopup()
* 
*  // 셀렉트 팝업이 화면에 보이는지/안보이는지
*  frontUI.Popup.isOpenSelectPopup()
* 
*  // 셀렉트 팝업 모두 닫기
*  frontUI.Popup.closeAllSelectPopup()
* 
*  // 현재 뜨는 순서대로 배열에 담김
*  frontUI.Popup.arrPopup
* 
*  // 팝업은 열림과 닫힘으로 이루어져 있고 요소에서 강제 제거시 정상작동이 안된다. 아래는 팝업요소와 html을 비교하여 교정하는 역할을 한다.
*  frontUI.Popup.cleanPopupStack()
*/


class Popup extends UI {
    static popupArraySetFn;
    static zIndex = 150;    // 팝업의 기본 z-index
    static arrPopup = [];   // 다중팝업일 경우 순서대로 배열로 쌓인다.
    static arrPrePopup = [];   // 다중팝업일 경우 순서대로 배열로 쌓인다.
    $popupContainer;        // popup의 컨테이너(.popup-wrap)
    $popupInner;        // popup-dialog가 생성되는 영역
    $dimm;                  // 팝업에서만 쓰는 딤드
    $popup;
    selector;
    popupType;
    static a11yDetectSelectClose= {isSelected:false, type:'default'}; //접근성 추가
    closeSelector = null; //팝업 열릴시 닫기후 돌아갈 target 지정
    static closeSelectors = null;
    focusA11yFunc = null;

    static loadInit(){
        // .popup-wrap이 없을 경우 생성해준다.
        // if (!$('#content-mmk > div').find('.popup-wrap')[0]) {
        //     $('#content-mmk > div').append(`<div class="popup-wrap"></div>`);
        // }

        // .kbank-page-container 형제레벨의 .popup-wrap이 없을 경우에만 생성해준다.(CHPFMTASK-1836 / 20250110수정)
        if ($("#content-mmk > div").find(".kbank-page-container").siblings(".popup-wrap").length < 1) {
            $('#content-mmk > div').find(".kbank-page-container").parent().append(`<div class="popup-wrap"></div>`);
        }
    }
   
    // /**
    //  * 팝업의 초기화시(init) popupInit을 호출하여 기본 골격을 구성하게 된다.
    //  * @param el        {HTMLElement}   html element
    //  * @param options   {object}        옵션
    //  * @param selector
    //  */
    popupInit(el, options, selector) {
        if (this.$el.hasClass('ui-popup')) { // FETASK-2010:  통합관리자  popup-wrap 2개일때 대비,  셀렉트,캘린더 대응
            this.$popupContainer = this.$el.closest('.popup-wrap');
        } else {
            if (this.$wrap.find('.popup-wrap').length > 1) {
                //this.$popupContainer = this.$wrap.find('.popup-wrap')
                this.$popupContainer = $(this.$wrap.find('.popup-wrap')[this.$wrap.find('.popup-wrap').length - 1])
            } else {
                this.$popupContainer = this.$wrap.find('.popup-wrap')
            }
        }

        

        //this.$popupContainer = this.$wrap.length > 0 ? this.$wrap.find('.popup-wrap') : this.$el.closest('.popup-wrap');
        
        this.selector = selector;
        /*! s: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
        const isA11yCheck = isA11yCheckVersion();
        /*! e: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */

        // .dimm이 없을 경우 생성해준다.
        if (!this.$popupContainer.find('.dimm')[0]) {
            this.$popupContainer.append(`<div class="dimm"></div>`);
        }

        this.$dimm = this.$popupContainer.find('.dimm');

        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }

        $('.popup-dialog').is(':visible') && this.$body.css({overflow: 'hidden'}).find('.activeSlide .page-inner-scroll').css({overflow: 'hidden'});

        if (this.$el.closest('.ui-popup.ui-bottom[data-height-flexible="true"]').length && this.el.closest('.ui-popup.ui-bottom') !== this.el) {
            this.parentPop = this.$el.closest('.ui-popup.ui-bottom');
        } else {
            this.parentPop = null;
        }
        /*! s: FETASK-a11y page 2중팝업 케이스 접근성 추가 v.1.0.0 */
        if(isA11yCheck){
            const popupDialogEle = $('.popup-dialog.ui-bottom');
            const isCheckPopup = popupDialogEle.hasClass('ui-bottom');
            const popupUnderBtn = popupDialogEle.find('.btn-under-link');
            const popWrapEle = document.querySelector('.popup-depth2 .popup-content');

            if(isCheckPopup){
                popupUnderBtn.attr('role','button');
            }

            isA11yButtonRole();

            // setTimeout(()=>{
            //     a11yAcessFocus(this.$popup,true);
            // },1000);

        }
        /*! e: FETASK-a11y page 2중팝업 케이스 접근성 추가 v.1.0.0 */

        /*! s: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
        if (this?.$el[0] && this.$el[0]?.classList.contains('ui-popup') && isA11yCheck) {
            const that = this;
            const isCheckFullPopup = this.$el[0]?.classList.contains('ui-full');
            const isCheckFullPopupInCloseBtn = this.$el[0]?.querySelector('.btn-popup-close');

            // if(isCheckFullPopup && isCheckFullPopupInCloseBtn) return; //풀팝업이면서 닫기버튼 있을시 실행 안되게

            // A11YTASK-107 풀팝업일때 무조건 실행 안되게 변경
            if(isCheckFullPopup) return;

            const closeBtn = document.createElement('div');

            closeBtn?.setAttribute('role','button');
            closeBtn?.setAttribute('aria-hidden','false');
            closeBtn?.setAttribute('aria-label','팝업 닫기');

            closeBtn?.classList.add('close-btn');

            if($(this.$el[0]).find('.interest-group-top')[0]){
                $(this.$el[0]).find('.popup-content').parent().after(closeBtn);
            }else{
                if($(this.$el[0]).find('.popup-content').length){
                    if($(this.$el[0]).find('.popup-content').parent()?.length){
                        $(this.$el[0]).find('.popup-content').parent().after(closeBtn);
                    }else{
                        $(this.$el[0]).children().after(closeBtn);
                    }
                }else if($(this.$el[0]).find('.title-group .title-field-popup').length){
                    if($(this.$el[0]).find('.popup-content').parent()?.length){
                        $(this.$el[0]).find('.popup-content').parent().after(closeBtn);
                    }else{
                        $(this.$el[0]).children().after(closeBtn);
                    }
                }else if($(this.$el[0]).find('.popup-group').length){
                    if($(this.$el[0]).find('.popup-section')?.length){
                        $(this.$el[0]).find('.popup-section').after(closeBtn);
                    }else{
                        $(this.$el[0]).children().after(closeBtn);
                    }
                }else{
                    $(this.$el[0]).after(closeBtn);
                }
            }

            $(closeBtn).off('click').on('click', (e) => {
                e.preventDefault();
                
                if($(e.currentTarget).closest('.ui-popup')?.length){
                    $(e.currentTarget).closest('.ui-popup')?.trigger('click');
                }else{
                    this?.$el.data('ui').close();
                }

                const uiWidget = document.querySelector('.ui-widget');
                const activeSlide = document.querySelector('.activeSlide');

                if(!uiWidget && !activeSlide) return;

                setTimeout(() => {
                    const newArrPopup = [...new Set(Popup.arrPopup)];
                    
                    if(!newArrPopup?.length){
                        //팝업 다 닫히고 위젯 포커스
                        setTimeout(() => {
                            const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                            isCheckSelected && a11yAcessFocus(activeSlide, true);
                        });
                        uiWidget?.setAttribute('aria-hidden', 'false');
                        activeSlide?.setAttribute('aria-hidden', 'false');
                    }else{
                        uiWidget?.setAttribute('aria-hidden', 'true');
                        setTimeout(() => {
                            const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                            isCheckSelected && a11yAcessFocus(newArrPopup[newArrPopup?.length-1][0], true);
                        });
                    }
                },700);
            });

            const closeBtns = this.$el[0]?.querySelectorAll('.close-btn');

            
            closeBtns && closeBtns?.forEach((list,idx) => {
                if(idx > 0){
                    list.remove();
                }
            });
        }
        /*! e: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
    }

    
    popupScrollEvent(depth2){ // FETASK-1124 | 230630 :  팝업내 스크롤 이벤트 추가
        const that = this;
        let eventChk = false;
        let depthClass = '.popup-group:first-child .popup-content'
        if (depth2 != undefined) {
            depthClass = '.popup-group.popup-depth2 .popup-content';
            this.$popup.find('.popup-group .popup-content').off('scroll')
        } else {
            this.$popup.find('.popup-group.popup-depth2 .popup-content').off('scroll')
        }
        if (this.$popup.find(depthClass).scrollTop() > 0) {
            setTimeout(function(){
                that.$popup.addClass('pop-top-shadow')
            }, 800)
            
        }
        this.$popup.find(depthClass).off('scroll').on('scroll', function(){
            if ($(this).scrollTop() > 0) {
                if (eventChk == false) {
                    that.$popup.addClass('pop-top-shadow')
                    eventChk = true;
                }
            } else {
                that.$popup.removeClass('pop-top-shadow')
                eventChk = false;
            }
        })
    }
    
    popupContHeightCheck(){ // 231120  : pop-bot-shadow  동적으로 변경될수있게 변경
        if (this.$popup.attr('data-type') != 'dateSpinner' && !this.$popup.hasClass('ui-full')) { // FETASK-1124 | 230630 :  팝업내 스크롤 있을때 쉐도우 효과 클래스 추가
            this.$popup.removeClass('pop-bot-shadow')
            //   _maxHeight 값을 유동적으로 바꿈 231108
            if (Math.floor(this.$popup.find('.popup-group').outerHeight()) >= Math.floor(this.$popup?.find('.popup-group')?.css('max-height')?.replace('px',''))) {
                this.$popup.addClass('pop-bot-shadow')
                this.popupScrollEvent()
            }
            
        }
    }
   
    /**
     *
     * @param cancelMotion  {boolean}   true일 경우 팝업 애니메이션의 시간을 0초로 한다.
     * @param callback      {function}  팝업 애니메이션이 끝난 후의 콜백함수
     */
    closeCommonMotion({cancelMotion, callback}) {
        if (this.$popup.attr('data-close') == 'false') {
            return
        }
        this.closeCommonAction();
        if (!this.$popup) {
            return;
        }
        this.$dimm = this.$popup.closest('.popup-wrap').find('.dimm');  //FETASK-2010 | 240116 : 강제딤 이벤트 추가로 인한 수정
        const gsapTm = gsap.timeline();

        if (cancelMotion) {
            gsapTm.timeScale(100);
        }
        gsap.killTweensOf(this.$dimm);
    
        Popup.arrPrePopup = [... new Set(Popup.arrPrePopup)]
        if (this.popupPreLength === 0 || (this.popupPreLength === 1 && Popup.arrPrePopup[0].attr('data-id') === this.$popup.attr('data-id'))) {
            gsapTm.to(this.$dimm, {delay: 0, duration: 0.2, autoAlpha: 0}, 0);
            if (this.$popup.find('[data-role="animation-group"]').length > 0) { //230627 | FETASK-1048  팝업닫을시 애니메이션 클래스 removeClass
                this.$popup.find('[data-role="animation-group"]').each(function(idx,element){
                    $(element).removeClass('inScroll')
                })
            }
            if ($('html').hasClass('pc')) { //230627 | FETASK-1048  pc버전 팝업 닫을때 상단 위로 올리기
                this.$popup.find('.popup-group').scrollTop(0)
            }  else if ($('html').hasClass('mobile')){
                this.$popup.scrollTop(0)
            }

        } else {
            let lastPopupZIndex;
            if (Popup.arrPrePopup[Popup.arrPrePopup.length - 1].attr('data-id') === this.$popup.attr('data-id')) {
                // FETASK-813 풀팝업 -> 바텀팝업 dim 오류 
                if (!Popup.arrPrePopup[Popup.arrPrePopup.length - 2].hasClass('ui-bottom') && !Popup.arrPrePopup[Popup.arrPrePopup.length - 1].hasClass('ui-full')) {
                    gsapTm.to(this.$dimm, {delay: 0, duration: 0.2, autoAlpha: 0}, 0);
                } else {
                    // this.$dimm.css({zIndex: lastPopupZIndex - 1});
                    // if (this.$popup.attr('case') == 'calendar') { // 231013 : 캘린더 + 데이트스피너 문제...
                    //     lastPopupZIndex = Popup.arrPrePopup[0].css('z-index');
                    //     this.$dimm.css({zIndex: lastPopupZIndex - 1});
                    // }
                }
            } else {
                if (this.$popup.attr('case') == 'calendar') { // 231013 : 캘린더 + 데이트스피너 문제...
                    lastPopupZIndex = Popup.arrPrePopup[0].css('z-index');
                } else {
                    lastPopupZIndex = Popup.arrPrePopup[Popup.arrPrePopup.length - 1].css('z-index');
                }
                
                this.$dimm.css({zIndex: lastPopupZIndex - 1});
            }
        }
        if (this.$popup.attr('data-close') != undefined) {
            gsapTm.to(this.$dimm, {delay: 0, duration: 0.2, autoAlpha: 0}, 0);
        }
        if (this.$popup.hasClass('ui-bottom') && this.$popup.find('.popup-content').length > 0) {  // FETASK-1028 | 230621 | 반팝업내 스크롤영역 close되면서 스크롤 초기화
            this.$popup.find('.popup-content').scrollTop(0)
        }
        if (this.parentPop !== null && this.$popup.hasClass('ui-bottom')) {
            this.setParentHeight('close', this.parentPop);
        }
        gsapTm.to(this.$popup, {
            duration: 0.1, autoAlpha: 0, yPercent: 3, ease: Power0.easeOut, onComplete: () => {
                gsap.set(this.$popup, {display: 'none'});
                //this.$popup.scrollTop(0); // 230627 open 일때 스크롤 탑 0
                //  2023-06-08 | 팝업내 cta버튼 스와이퍼 닫히면 index - > 0 으로
                if (this.$popup.find('[data-type="cta"]').length > 0) {
                    if (this.$popup.find('[data-type="cta"] .swiper-slide').length > 1) {
                        this.$popup.find('[data-type="cta"]').data('ui').swiper.slideTo(0)
                    }
                }
                if (this.popupLength === 0 || (this.popupLength === 1 && Popup.arrPopup[0].attr('data-id') === this.$popup.attr('data-id'))) {
                    const thisPage1 = this.$body.find('.kbank-page-PBKOFR001000A100S_M01');
                    const thisPage2 = this.$body.find('.kbank-page-PBKOFR001000A100S_M02');
                    if(thisPage1.length > 0 || thisPage2.length > 0){ //CHPFMTASK-1761 : 입출금리워드 페이지일경우(2024.12.27)
                        setTimeout(() => {
                            this.$body.removeAttr('style').find('.page-inner-scroll').css('overflow', '');
                        }, 300);
                    } else { //CHPFMTASK-1761 : 입출금리워드 페이지가 아닐경우(2024.12.27)
                        this.$body.removeAttr('style').find('.page-inner-scroll').css('overflow', '');
                    }
                }
                this.$popup.attr('popup-show', false) //  CHPFMTASK-801
                // this.$window.scrollTop(this.savedScrollY);
                //scrollTo(this.savedScrollY);
                callback && callback();
            }
        }, 0);

        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        if (this.popupLength === 0) {
            isA11yCheckVersion() && this.accessClose();
        }
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */

        // FETASK-1499 | Dimmed 영역 스크롤 방지 해제
        if($('.main-tab-container').length){
            preventScroll(false);
        }

        clearTimeout(Popup.popupArraySetFn);
        Popup.popupArraySetFn = setTimeout(() => {
            if (Popup.arrPrePopup.length > 0) {
                for(let i = 0; i < Popup.arrPrePopup.length; i++) {
                    if (!Popup.arrPrePopup[i].is(':visible')) {
                        Popup.arrPrePopup.splice(i, 1)
                        i--;
                    }
                }
            }
    
            if (Popup.arrPopup.length > 0) {
                for(let i = 0; i < Popup.arrPopup.length; i++) {
                    if (!Popup.arrPopup[i].is(':visible')) {
                        Popup.arrPopup.splice(i, 1)
                        i--;
                    }
                }
            }
        }, 300);

        // if (Popup.arrPrePopup.length > 0) { //2022-09-26 통신 후 생성된 팝업 close시 간헐적 dim 이슈 대응, 2022-11-05 상단 Popup.popupArraySetFn 수정
        //     let ShowPop = 0;

        //     Popup.arrPopup.forEach((popup) => {
        //         if (popup.is(':visible')) {
        //             ShowPop = ShowPop + 1;
        //         }
        //     })

        //     if (ShowPop === 0) {
        //         this.$dimm.css({'opacity': 0});
        //     }
        // }

        /*! s: FETASK-a11y page 팝업 v.1.0.0 */
        if(isA11yCheckVersion()){
            //이벤트 팝업 닫힐때 선택자 설정
            if(this?.defaults?.type === 'banner' && $('.btn-home-tab1.on')?.length){
                $('.btn-logo-kbank').attr('id', `btn-logo-kbank`);
                $('.btn-logo-kbank').attr({'aria-hidden':'false', 'tabindex':'-1', 'alt':'홈 로고'});

                this.closeSelector = `#btn-logo-kbank`;
                Popup.closeSelectors = `#btn-logo-kbank`;
            }

            setTimeout(() => {
                const popupEles = document.querySelectorAll('.ui-popup'); //모든팝업 선택

                const newArrPopup = [...new Set(Popup.arrPopup)];

                const removeIdContent = document?.querySelector('#content-mmk');
                removeIdContent?.setAttribute('aria-hidden','false')
                removeIdContent?.removeAttribute('aria-hidden');

                popupEles?.forEach((item) => {
                    item.setAttribute('aria-hidden','true');
                    item.classList.remove('activePopup');
                    $(item).parent().attr('aria-hidden','true');
                });

                if(!!newArrPopup?.length){
                    newArrPopup[newArrPopup?.length-1].attr('aria-hidden','false');

                    if(newArrPopup[newArrPopup?.length-1]?.classList?.contains('activePopup')){
                        //PoupAlert close 접근성 대응
                        newArrPopup[newArrPopup?.length-1]?.removeAttribute('role','dialog');
                    }
                    
                    setTimeout(() => {
                        const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                    
                        newArrPopup[newArrPopup?.length-1].parent()?.removeAttr('aria-hidden');
                        isCheckSelected && a11yAcessFocus(newArrPopup[newArrPopup?.length-1][0], true);
                    });
                }else{
                    const activeItem = document.querySelector('.activeSlide');
    
                    setTimeout(() => {
                        const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                        if (this.$popup?.attr('data-focus-event') == undefined) { //240628  팝업 닫힐때  포커스 이동하는거 막는 조건
                            isCheckSelected && a11yAcessFocus(activeItem, true);
                        }
                        
                        
                    });
                }
            },700);
        }
        /*! e: FETASK-a11y page 팝업 v.1.0.0 */
    };
    
    /**
     *
     * @param cancelMotion  {boolean}   true일 경우 팝업 애니메이션의 시간을 0초로 한다.
     * @param callback      {function}  팝업 애니메이션이 끝난 후의 콜백함수
     */
    openCommonMotion({cancelMotion, callback}) {
        // 팝업을 열기 전의 스크롤 값을 저장해놓는다.
        this.savedScrollY = scrollY;
        // 팝업이 열릴 경우 #container의 position를 fixed로 변경하여 내부스크롤을 쓰지 않고 문서의 스크롤을 쓴다.
        // this.$container.css({position: 'fixed', top: -scrollY});
        this.$body.css({overflow: 'hidden'}).find('.activeSlide .page-inner-scroll').css({overflow: 'hidden'});
        // s: 20230216 넘패드 실행전에 설정값 변경시 자동 업데이트
        // var webnumpadEl = $(this.$popup[0]).find(".ui-webnumpad[data-type='amount']");
        // if (webnumpadEl.length > 0) webnumpadEl.data('ui').refreshNumpad();
        // e: 20230216 넘패드 실행전에 설정값 변경시 자동 업데이트
       


        this.removeDuplicateDimm();
        if (this.$popup[0].classList.contains('ui-popup')) {
            Popup.arrPrePopup.push(this.$popup);
        }
        const gsapTm = gsap.timeline();
        if (cancelMotion) {
            gsapTm.timeScale(100);
        }

        const dimmZindex = this.dimmZIndex;
        const popupZIndex = this.popupZIndex;

        if (this.$popup[0].classList.contains('ui-full')) {  // 24-03-20 팝업 타입 추가
            this.popupType = 'full';
        } else if (this.$popup[0].classList.contains('ui-simple')) {
            this.popupType = 'layer';
        } else if (this.$popup[0].classList.contains('ui-bottom')) {
            this.popupType = 'bottom';
        }
        // SR-1860 스피너 팝업 아닐시 팝업 dimm X
        if (this.$popup[0].classList.contains('ui-popup')) {
            gsap.killTweensOf(this.$dimm);
            // 열려있는 팝업이 없을 경우엔 dimm을 애니메이션 시키고 아닐경우 z-index만 조정해준다.
            if (this.popupLength === 0) {
                let _duration = 0.2  // CHPFMTASK-936 
                let _alpha = 0  // CHPFMTASK-936 
                if(this.$popup.hasClass('ui-full')){
                    gsapTm.fromTo(this.$dimm,
                        {display: 'block', autoAlpha: 0, zIndex: dimmZindex},
                        {duration: _duration, autoAlpha: 0},
                        0);
                }else{

                    if (this.$popup.attr('data-effect') == 'fade') { // CHPFMTASK-936 
                        _duration = 0
                        _alpha = 0.7
                    }
                    gsapTm.fromTo(this.$dimm,
                        {display: 'block', autoAlpha: _alpha, zIndex: dimmZindex},
                        {duration: _duration, autoAlpha: 0.7},
                        0);
                }
            } else {
                if(this.$popup.hasClass('ui-full')){
                    gsapTm.add(gsap.timeline()
                            .to(this.$dimm, {autoAlpha: 0.6, duration: 0.1})
                            .to(this.$dimm, {autoAlpha: 0.7, duration: 0.1})
                        , 0)
                }else{
                    if (this.parentPop === null) {
                        gsapTm.add(gsap.timeline()
                            .to(this.$dimm, {autoAlpha: 0.6, duration: 0.1, zIndex: popupZIndex - 1})
                            .to(this.$dimm, {autoAlpha: 0.7, duration: 0.1})
                        , 0)
                    }
                }
                // this.$dimm.css({zIndex: popupZIndex - 1});
            }
        }

        if ($('.popup-wrap').attr('aria-hidden') === 'true') {
            $('.popup-wrap').removeAttr('aria-hidden');
        }
        if (cancelMotion) {
            const _opactiy = this.defaults.opacity != undefined ? this.defaults.opacity : 1;
            gsapTm.set(this.$popup, {display: 'flex', autoAlpha: _opactiy, yPercent: 0, zIndex: popupZIndex});
            setTimeout(() => {
                //this.$popup.scrollTop(0); // 230627 | close 될때 실행함
                // s: callback 시점 변경
                frontUI.moveItemFocusMove(this.$popup);
                this.openCommonAction();
                callback && callback();
                // e: callback 시점 변경
            });

            if (this.parentPop !== null && this.$popup.hasClass('ui-bottom')) {
                this.setParentHeight('open', this.parentPop, cancelMotion);
            }
        }else{
            if (this.parentPop !== null && this.$popup.hasClass('ui-bottom')) {
                gsapTm.fromTo(this.$popup,
                    {display: 'flex', autoAlpha: 0.6, yPercent: 0, zIndex: popupZIndex},
                    {
                        delay: 0, duration: 0.1, autoAlpha: 1, ease: 'linear',
                        onStart: () => {
                            // this.$popup.scrollTop(0); // 230627 | close 될때 실행함
                            frontUI.moveItemFocusMove(this.$popup);
                        },
                        onComplete: () => {
                            this.$popup?.css({transform: 'none'});
                            // s: callback 시점 변경
                            this.openCommonAction();
                            callback && callback();
                            // e: callback 시점 변경
                        }
                    },
                    0);
                this.setParentHeight('open', this.parentPop);
            } else {
                let popupDelay =0.2
                let popupYPercent = 20
                if (this.popupType == 'layer' && this.popupType != undefined) {
                    popupDelay = 0;
                    popupYPercent = 8
                }
                if (this.$popup.attr('data-effect') == 'fade') { // CHPFMTASK-936 
                    popupYPercent = 0
                    popupDelay =0
                }
                gsapTm.fromTo(this.$popup,
                    {display: 'flex', autoAlpha: 0, yPercent: popupYPercent, zIndex: popupZIndex},
                    {
                        delay: popupDelay, duration: 0.4, autoAlpha: 1, yPercent: 0, ease: 'Power3.easeOut',
                        onStart: () => {
                            
                            frontUI.moveItemFocusMove(this.$popup);
                            frontUI.popupBotBtnHideOpen(this.$popup) // FETASK-1540 전체팝업 하단 버튼 스크롤시 보이는 이벤트
                            //  FETASK-1500 팝업 높이  max-height:60vh 인경우 추가 
                            // let _maxHeight = 88;
                            // if (this.$popup.find('.hv-60').length > 0) {
                            //     _maxHeight = 60;
                            // }
                            this.popupContHeightCheck() // FETASK-1124 | 230630 :  팝업내 스크롤 있을때 쉐도우 효과 클래스 추가
                            // this.$popup.scrollTop(0); // 230627 | close 될때 실행함
                            // if (this.$popup.find('.select-item .btn-option.selected').length > 0) { // CHPFMTASK-1714 삭제
                            //     console.log('selectScrollEvent2')
                            //     frontUI.selectScrollEvent(this.$popup); // FETASK-1681
                            // }
                        },
                        onComplete: () => {
                            this.$popup?.css({transform: 'none'});
                            if(this.$popup?.find('[ani-count-wrap]')){ // FETASK-1048  |  230621 | 숫자카운트 스크롤 시 이벤트 
                                frontUI.numberCountAniScroll()
                            }
                            // s: callback 시점 변경
                            this.openCommonAction();
                            this.$popup?.attr('popup-show', true) //  CHPFMTASK-801
                            callback && callback();
                            // e: callback 시점 변경
                        }
                    },
                    0);
            }
            // if (this.$popup.find('.ui-input').length > 0) {
            //     for (var i =0; i < this.$popup.find('.ui-input').length; i ++) {
            //         $(this.$popup.find('.ui-input')[i]).data('ui').valueChkHiddenBtn();  // 230321 팝업 오픈시 input 영역 value 값 있을때  delete 버튼 바로 활성화 추가
            //     }
                
            // }
        }

        // this.$window.scrollTop(0);
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        if (this.popupLength === 0 && isA11yCheckVersion()) {
            $('.food-alarm-pop').data('ui')?.update(); //ui-swiper popup open시 재생,정지버튼
            //this.accessOpen();
        }

        if(this?.defaults?.type === 'banner' && $('.btn-home-tab1.on')?.length){
            let count = 0;
            let interval = setInterval(() => {
                $('.btn-logo-kbank')?.blur();
                $('.btn-logo-kbank').attr({'aria-hidden':'true', 'alt':'홈 로고', 'tabindex':'-1'});
                if(count >= 5){
                    clearInterval(interval);
                }
                count++;
            },100);
        }
        /*! e: FETASK-a11y page Popup 수정 v.1.0.0 */

        this.uiCommonAction();

        // CHPFMTASK-2128 : 반팝업타이틀 동적변경
        if(this.$el && this.$popup && this.popupType === 'bottom'){
            const selectBtn = this.$el.closest('.ui-input').find('.ui-select-btn');
            if(selectBtn.length > 0) {
                let getTitle = null, getSubTitle = null;

                const uiInputTitle = selectBtn.closest('.ui-input').attr('data-title'),
                uiInputSubtitle = selectBtn.closest('.ui-input').attr('data-sub-title'),
                btnTitle = selectBtn.attr('title'), btnSubtitle = selectBtn.attr('data-sub-title');
                
                if(uiInputTitle) getTitle = uiInputTitle; // ui-input에 data-title 있을때
                if(uiInputSubtitle) getSubTitle = uiInputSubtitle; // ui-input에 data-sub-title 있을때
                if(!uiInputTitle && btnTitle) getTitle = btnTitle; // ui-input에 data-title 없고 ui-select-btn에 title 있을때
                if(!uiInputSubtitle && btnSubtitle) getSubTitle = btnSubtitle; // ui-input에 data-sub-title 없고 ui-select-btn에 data-sub-title 있을때
                
                const txtGuidePopup = this.$popup.find('.txt-guide-popup');
                if(getTitle && getTitle != '') this.$popup.find('.title-field-popup')?.html(getTitle);
                if(getSubTitle && getSubTitle != ''){
                    if(txtGuidePopup.length < 1) this.$popup.find('.title-group').append(`<p class="txt-guide-popup"></p>`);
                    txtGuidePopup.css('display','block');
                    txtGuidePopup.html(getSubTitle);
                } else {
                    txtGuidePopup.empty();
                    txtGuidePopup.css('display','none');
                }

                // CHPFMTASK-2418 : 충전금액 의 직접입력케이스 타이틀 동적 변경(2025.06.10)
                const labelFieldEle = this.$el.closest('.selectbox-group').find('.selectbox-label-field').text()
                this.$el.parent().parent().find('.input-txt-group .label-field').text(labelFieldEle)
            }
        }
    };
    
    openCommonAction() {
        // console.log('openCommonAction')
        // SR-1860 스피너 팝업 아닐시 팝업 배열 추가 x
        if (this.$popup[0].classList.contains('ui-popup')) {
            Popup.arrPopup.push(this.$popup);
            Popup.arrPopup.findIndex((popup) => {
            });
        }
        frontUI.refreshUI();
        // 팝업 내 제목 태그 변경되어서 수정 필요함 : 0224
        // 팝업 접근성: 팝업 내의 h1요소에 role=text tabindex=0속성 추가 후 초첨 이동 제공
        // 230629 | 접근성 잠시 막아둠
        // if (this.$popup.find('[data-auto-focus]').length > 0) {
        //     const focusEl = this.$popup.find('[data-auto-focus]').eq(0).find('input, a, button')[0];
        //     setTimeout(() => {
        //         $(focusEl).focus().trigger('focusin');
        //     }, 450)
        // } else {
        //     if (this.$popup.find('.ui-popup-pointer').length <= 0) {
        //         let headerText = '팝업 시작';
        //         if (this.$popup.find('h1').length > 0) {
        //             headerText = this.$popup.find('h1').text();
        //         }
        //         // SR-1860 스피너 팝업 아닐시 팝업 시작 문구 삭제
        //         if (this.$popup[0].classList.contains('ui-popup')) {
        //             this.$popup.prepend(`<div class="ui-popup-pointer hide-txt" role="text" tabindex="0">${headerText}</div>`);
        //         }
        //     }
        //     setTimeout(() => {
        //         this.$popup.find('.ui-popup-pointer').focus();
        //     }, 300)
        // }
        
        frontUI.aniDelay(this.$popup); // FETASK-1261 : 230810 추가
        // frontUI.logoScrollLoop();  // FETASK-1748 250219 주석처리
        frontUI.puzzleEventDrag();
        // frontUI.FETASK1681Event(this.$popup); // FETASK-1681

        // CHPFMTASK-2128 바텀시트에 Tab + DateSpinner 함께 있는 경우
        if (this.$popup.find('.ui-ToggleRadio').length > 0 &&  this.$popup.find('.group-spinner').length > 0) {
            this.$popup.addClass('pop-bot-shadow');
        }  
        // 240226 : 팝업에 로띠 재 실행
        
        if (this.$popup.find('.ui-lottie').length > 0 ) {  // 240226 : 팝업에 로띠 재 실행
            this.$popup.find('.ui-lottie').each(function(idx,el){
                if ($(el).attr('data-loaded') == 'true') {
                    $(el).data('ui').update()
                }
            })
        }
        if (Popup.arrPopup?.length > 0) { // 240909  팝업 오픈 클래스 
            if (!this.$popup.hasClass('ui-popup-open')) {
                const popupElement = document.querySelectorAll('.ui-popup'); //모든팝업 선택
                popupElement?.forEach((item) => {
                    item.classList.remove('ui-popup-open');
                    $(item).parent().attr('aria-hidden','true');
                });
                this.$popup.addClass('ui-popup-open')
                $('.inandout-scroll ').addClass('scrolling');
            }
        }
        
        /*! s: FETASK-a11y page 팝업 v.1.0.0 */
        
        if(isA11yCheckVersion()){
            // console.log('isA11yCheckVersion')
            setTimeout(() => {
                const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
            
                if(isCheckSelected){
                    this.a11yPopupDepth2();
                }
            });

            const removeIdContent = document?.querySelector('#content-mmk');
            removeIdContent?.setAttribute('aria-hidden','false')
            removeIdContent?.removeAttribute('aria-hidden');

            const popupEles = document.querySelectorAll('.ui-popup'); //모든팝업 선택
            isA11ySetAttr(popupEles,'aria-hidden', 'true');
            
            setTimeout(() => {
                const newArrPopup = [...new Set(Popup.arrPopup)];
                if(newArrPopup?.length > 0){
                    if(this.$popup.closest('[data-mapping-toggle]')?.length && this.$popup.closest('[data-spinner-area]')){
                        popupEles?.forEach((item) => {
                            item.setAttribute('aria-hidden','true');
                            item.classList.remove('activePopup');
                            
                            $(item).parent().attr('aria-hidden','true');
                        });
                        this.$popup[0].classList.add('activePopup');
                        this.$popup[0].setAttribute('aria-hidden','false');
                        this.$popup[0].parentElement.removeAttribute('aria-hidden');
                        this.$popup.closest('.popup-wrap').removeAttr('aria-hidden');
                        
                        if(this.$popup.closest('.ui-popup')?.length && this.$popup.closest('[data-type="dateSpinner"]')?.length){
                            //팝업안 데이트 스피너 형태
                            let count = 0;
                            let interval = setInterval(() => {
                                this.$popup.closest('[data-type="dateSpinner"]').attr('aria-hidden','false');
                                if(count >= 20){
                                    clearInterval(interval);
                                }
                                count++;
                            },100);
                        }
                    }else{
                        popupEles?.forEach((item) => {
                            item.setAttribute('aria-hidden','true');
                            item.classList.remove('activePopup');
                            $(item).parent().attr('aria-hidden','true');
                        });
                        this.$popup[0].classList.add('activePopup');
                        this.$popup[0].setAttribute('aria-hidden','false');
                        this.$popup[0]?.parentElement?.removeAttribute('aria-hidden');
                    }
                    
                }

                const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';

                //TODO 2024.05.23 배포 주석
                if(this.$popup.find('.group-spinner-swiper')?.length){
                    setTimeout(() => {
                        isA11ySwiperSpinnerUpdate(this.$popup);
                    },800);
                }

                isCheckSelected && a11yDebounce(isA11ySwiperPopupUpdate(Popup.arrPopup));

                if(newArrPopup?.length){
                    isCheckSelected && a11yDebounce( a11yAcessFocus(newArrPopup[newArrPopup?.length-1][0], false));
                }else{
                    const activeItem = document.querySelector('.activeSlide');
                    isCheckSelected && a11yDebounce(a11yAcessFocus(activeItem, false));
                }
                
                //다중 popup-wrap 대응
                if(this.$popupContainer.parent().hasClass('popup-wrap')){
                    this.$popupContainer.parent().removeAttr('aria-hidden');
                }

                // S---- A11YTASK-481, A11YTASK-476 스피너 팝업일때 포커스 막는로직 실행안함 ----

                // 마크업 구조로 비교시
                // if(this.$popup.attr('data-spinner-area') && this.$popup.closest('.ui-popup').length > 0){
                //     if(this.$popup.closest('.ui-popup').find('.ui-ToggleRadio').length > 0){
                //         console.log('상위 요소에 토글 라디오 있음');
                //     }
                // }

                // 데이터가 스피너이고 date 요소가 있는지로 비교할때
                if(this.defaults.date === undefined){
                    this.focusA11yFunc = new FocusTrap({
                        containerDomNode: this.$popup[0], //해당 기준 빼고 포커스 다 막는로직 실행
                        initialFocusDomNode: this.$popup[0], //팝업 열렸을때 보낼곳
                        sourceDomNode: this.closeSelector || null, //팝업 닫을때 보낼곳
                        useFocus:false //키보드 이벤트 적용여부
                    });
                    this.focusA11yFunc && this.focusA11yFunc.activate(); //팝업 열때
                }

                // E---- A11YTASK-481, A11YTASK-476 스피너 팝업일때 포커스 막는로직 실행안함 ----
                
            });
            
            // A11YTASK-218 : 접근성대응(2025-03-31)
            const pageElement = document?.querySelectorAll('.ui-kbank-page-control');
           
            pageElement?.forEach((item) => {
                item.setAttribute('aria-hidden','true');
                item.setAttribute('tabindex','-1');
            });
        }

        /*
        const gsapTm = gsap.timeline();
        this.$dimm = this.$popup.closest('.popup-wrap').find('.dimm');
        gsap.killTweensOf(this.$dimm);

        if (newArrPopup?.length === 0) {
            gsapTm.fromTo(this.$dimm,
                {display: 'block', autoAlpha: 0, zIndex: this.dimmZIndex-5},
                {duration: 0.2, autoAlpha: 0.7},
            0);
        } else {
            gsapTm.add(gsap.timeline()
                .to(this.$dimm, {display: 'block',autoAlpha: 0.6, duration: 0.1, zIndex: this.popupZIndex - 6})
                .to(this.$dimm, {autoAlpha: 0.7, duration: 0.1})
            , 0)
        }
        */
        /*! e: FETASK-a11y page 팝업 v.1.0.0 */
    }

    /*! s: FETASK-a11y page 팝업 v.1.0.0 */
    a11yPopupDepth2(){
        //depth2 케이스 접근성 대응
        if(!$('.activePopup').find('.popup-depth2')) return;

        let $popupDepth1, $popupDepth2, $depth2Button, $popup;
        $('.activePopup').find('.popup-depth2').attr({'aria-hidden':'true'});
    
        $('.activePopup').on(`click${this.eventId}` , '[popup-depth2-button]', function(){
            $depth2Button = $(this);
            $popup = $depth2Button.closest('.ui-popup')
            $popupDepth1 = $(this).closest('.popup-group');
            $popupDepth2 = $(this).closest('.popup-section').find('.popup-depth2');
            
            $popupDepth1.attr({'aria-hidden':'true'});
            $popupDepth2.addClass('active').removeAttr('aria-hidden');
            
            $popupDepth2.on('transitionend',() => {
                if(!$popupDepth2.hasClass('active')) return;
                $popupDepth2?.find('.btn-back').blur();

                setTimeout(() => {
                    $popupDepth2?.find('.btn-back').focus();
                },1000);
            });

            $popupDepth2.find('.btn-back').on('click', function(){
                $popupDepth1.removeAttr('aria-hidden');
                $popupDepth2.removeClass('active').attr({'aria-hidden':'true'});

                setTimeout(() => {
                    $depth2Button.blur();
                },500);

                setTimeout(() => {
                    $depth2Button.focus();
                },1000);
            });
        });
    }

    a11yClickSelectorTarget(target){
        //클릭하여 팝업 오픈한 selector로 close시 해당 타켓으로 돌아가게함.
        this.closeSelector = target;
        Popup.closeSelectors = target;

        $(target)?.attr({'aria-hidden':'false','tabindex':'0'});
    }

    static a11yClickSelectorTargetInit(){
        this.closeSelector = null;
        Popup.closeSelectors = null;
    }
    /*! e: FETASK-a11y page 팝업 v.1.0.0 */

    closeCommonAction() {
        

        const index = Popup.arrPopup.findIndex((popup) => {
            return popup.data('id') === this.$popup.data('id');
        });
        if (this.$popup.find('[data-fade-wrap]').length > 0) { // FETASK-1647
            setTimeout(()=>{
                this.$popup.find('[data-fade-wrap]').attr('fade-active-index', 0);
                this.$popup.find('[data-puz-event]').removeAttr('puzzle-step')
                this.$popup.find('[data-puz-event]').find('.ui-tooltip').removeAttr('style')
                this.$popup.find('[rotate-pos]').each(function(){
                    $(this).removeAttr('rotate-pos')
                })
                frontUI.puzzleEvent()
                frontUI.fadeAction(0)
            },200)
            
        }
        if(index >= 0){
            Popup.arrPopup.splice(index, 1);
            Popup.arrPrePopup.splice(index, 1);
        }

        if (this.$popup.attr('select-bank') !== undefined) { // CHPFMTASK-1445 241021  은행증권 셀렉트 팝업 접근성 포커스 이슈
            this.a11yClickSelectorTarget(`[select-popup="${this.$popup.attr('select-bank')}"] .btn-selectbox`)
        }
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        if(isA11yCheckVersion()){
            a11yShowOtherContent(this.$popupContainer, false);

            $('.carousel-group').removeAttr('aria-hidden');
            this.focusA11yFunc && this.focusA11yFunc.deactive(); //팝업 닫을때

            setTimeout(() => {
                if(Popup?.arrPopup?.length){
                    $('.ui-widget').attr('aria-hidden','true');
                }else{
                    $('.ui-widget').attr('aria-hidden','false');
                }
            });

            // A11YTASK-218 : 접근성대응(2025-03-31)
            const pageElement = document?.querySelectorAll('.ui-kbank-page-control');
           
            pageElement?.forEach((item) => {
                if($(item).hasClass('activeSlide')){
                    item.setAttribute('aria-hidden','false');
                    item.removeAttribute('tabindex');
                } else {
                    item.setAttribute('aria-hidden','true');
                    item.setAttribute('tabindex','-1');
                }
            });
        }
        /*! e: FETASK-a11y page Popup 수정 v.1.0.0 */

        // CHPFMTASK-2039 달력 팝업 닫을때 뒤에 다른팝업 있으면 다시 띄움
        // if(this?.defaults?.type && this?.defaults?.type === 'calendar' && this?.$popup && Popup?.arrPopup?.length) {
        //     if(Popup.arrPopup[0] != this.$popup[0]) Popup.arrPopup[0].data('ui').open(true);
        // }
    }

    removeDuplicateDimm(){
        const $dimm = this.$popupContainer.find('.dimm');
        if($dimm.length > 1){
            $dimm.slice(1, $dimm.length).remove();
        }
    }

    accessOpen() {
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        a11yHideOtherContent(this.$popupContainer, true);
        /*! e: FETASK-a11y page Popup 옵션 수정 v.1.0.0 */

        if (this.$popup.find('.ui-ToggleRadio').length) {
            $('.ui-ToggleRadio').each((index, item) => {
                $(item).data('ui').update();
            });
        }
    }

    accessClose() {
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        if (this.popupLength === 0) {
            if ( $('.nudge_content .list').is(':visible') ) {
                a11yHideOtherContent($('#nudge'), true);
            } else {
                a11yShowOtherContent(this.$popupContainer);
            }
        }
        /*! e: FETASK-a11y page Popup 수정 v.1.0.0 */
    }
    
    static a11yDetctClosePopup(){
        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        //팝업 셀렉트 형태 혼합시 셀렉트팝업 close될때 실행 안되게 분기
        
        Popup.a11yDetectSelectClose = { isSelected:true, type:'select' };
        
        setTimeout(() => {
            Popup.a11yDetectSelectClose = { isSelected:false, type:'default' };
        },1200);
        /*! e: FETASK-a11y page Popup 수정 v.1.0.0 */
    }

    a11yPreventFocus(){
        //static제거 예외케이스 팝업 포커스 막는 용도로 추가 활용
        Popup.a11yDetectSelectClose = { isSelected:true, type:'select' };
        
        setTimeout(() => {
            Popup.a11yDetectSelectClose = { isSelected:false, type:'default' };
        },1000);
    }

    setParentHeight(status, parentPop, motion = null){
        var time = (motion === null) ? 100 : 0;
        if (status === 'close') {
            parentPop.find('.popup-group').animate({
                'opacity': 1,
                'height': parentPop.find('.popup-group').attr('data-origin-height'),
            }, time, 'linear', () => {
                parentPop.find('.popup-group').css({
                    'height': ''
                });
                parentPop.find('.popup-group').removeAttr('data-origin-height');
            });
        } else {
            const changeHeight = window.getComputedStyle(this.$popup.find('.popup-group')[0]).height;
            const originHeight = window.getComputedStyle(this.parentPop.find('.popup-group')[0]).height;
            parentPop.find('.popup-group').attr('data-origin-height', originHeight);
            parentPop.find('.popup-group').animate({
                'opacity': 0,
                'height': changeHeight,
            }, time, 'linear');
        }
    }

    uiCommonAction(){
        // FETASK-1499 | Dimmed 영역 스크롤 방지
        if($('.main-tab-container').length){
            preventScroll(true);
        }
        // FETASK-1579 | chip버튼 더보기 활성
        if(this.$popup.find('.ui-expand').length){
            [...this.$popup.find('.ui-expand')].forEach((ui) => {
                $(ui).hasClass('keyword-select-chips') && $(ui).data('ui').update();
            })
        }

        //팝업 닫기 iOS버그 대응
        if(isA11yCheckVersion()){
            this.$popup?.find('.close-btn')
                ?.attr('style', `
                position:fixed;
                top:0;
                left:0;
                z-index:-9999;
                width:100%;
                height:calc(100% - ${this.$popup.find('.popup-group').outerHeight()}px);
            `);
            
            //$('.ui-widget').attr('aria-hidden','true'); //접근성 위젯 막기
        }
    }

    /**
    * FETASK-2010 : 강제 dimm 이벤트 
    * @example 
    *  $('.ui-popup').data('ui').dimmSetup();
    */
    dimmSetup(){ //FETASK-2010 | 240116 : 강제딤 이벤트 추가로 인한 수정
        if (!this.$popup.closest('.popup-wrap').find('.dimm')[0]) {
            this.$popup.closest('.popup-wrap').append(`<div class="dimm"></div>`);
        }
        const gsapTm = gsap.timeline();
        this.$dimm = this.$popup.closest('.popup-wrap').find('.dimm')
        gsap.killTweensOf(this.$dimm);

        if (this.popupLength === 0) {
            gsapTm.fromTo(this.$dimm,
                {display: 'block', autoAlpha: 0, zIndex: this.dimmZIndex-5},
                {duration: 0.2, autoAlpha: 0.7},
            0);
        } else {
            gsapTm.add(gsap.timeline()
                .to(this.$dimm, {display: 'block',autoAlpha: 0.6, duration: 0.1, zIndex: this.popupZIndex - 6})
                .to(this.$dimm, {autoAlpha: 0.7, duration: 0.1})
            , 0)
        }
    }
    
    /**
     * dimm의 z-index값.
     * @returns {number}
     */
    get dimmZIndex() {
        return this.popupZIndex - 1;
    }

    /**
     * popup의 z-index값.
     * @returns {number}
     */
    get popupZIndex() {
        Popup.zIndex += 5;

        return Popup.zIndex;
    }
    /**
     * 생성된 popup의 갯수.
     * @returns {number}
     */
    get popupLength() {
        return Popup.arrPopup.length;
    }

    get popupPreLength() {
        return Popup.arrPrePopup.length;
    }

    /**
     * 풀팝업이 화면에 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenFullPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return popup.hasClass('ui-full');
        })
    }

    static selectBottomPopup(popup){
        return popup.hasClass('ui-bottom') && (
            !popup.data('type') ||
            popup.data('type') === 'banner' ||
            popup.data('type') === 'select-double-state' ||
            popup.data('type') === 'select-single-state'
        );
    }
    
    static dataClosePopup(popup){
        return popup.hasClass('ui-bottom') && (
            popup.attr('data-close')
        );
    }

    static selectSelectPopup(popup){
        return popup.hasClass('ui-bottom') && (
            popup.data('type') === 'select-single' ||
            popup.data('type') === 'select-double' ||
            popup.data('type') === 'dateSpinner' ||
            popup.data('type') === 'select' ||
            popup.data('type') === 'select-openbank' ||
            popup.data('type') === 'select-phone' ||
            popup.data('type') === 'select-bank'
        );
    }
    static selectFullPopup(popup){ // 240719  | CHPFMTASK-1100
        return popup.hasClass('ui-full');
    }

    /**
     * 반팝업이 화면에 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenBottomPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return Popup.selectBottomPopup(popup);
        })
    }

    /**
     * 반팝업 모두 닫기.
     */
    static closeAllBottomPopup(){
        Popup.arrPrePopup.filter((popup) => {
            return Popup.selectBottomPopup(popup);
        }).forEach((popup) => {
            popup.data('ui').close();
           
        })
    }

     /**
     * 셀렉트 팝업이 화면에 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenSelectPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return Popup.selectSelectPopup(popup);
        })
    }

    /**
     * 셀렉트 팝업 모두 닫기.
     */
    static closeAllSelectPopup(){
        Popup.arrPrePopup.filter((popup) => {
            return Popup.selectSelectPopup(popup);
        }).forEach((popup) => {
            popup.data('ui').close();
        })
    }
    
    /**
     * 풀팝업 모두 닫기.
     */
    static closeAllFullPopup(){ // 240719  | CHPFMTASK-1100
        Popup.arrPrePopup.filter((popup) => {
            return Popup.selectFullPopup(popup);
        }).forEach((popup) => {
            popup.data('ui').close();
        })
    }

    /**
     * 앨럿 팝업이 화면에 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenAlertPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return popup.hasClass('ui-alert');
        })
    }
    static checkPopup(){
        return Popup.arrPopup
    }

    /**
     * 어떤종류의 팝업이던지 화면이 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return popup.hasClass('ui-popup');
        })
    }

    /**
     * 달력 팝업이 화면에 보이는지/안보이는지 확인.
     * @returns {boolean}
     */
    static isOpenCalendarPopup(){
        return Popup.arrPrePopup.some((popup) => {
            return popup.attr('data-type') === 'calendar';
        })
    }

    /**
     * 달력 팝업 모두 닫기.
     */
    static closeAllCalendarPopup(){
        return Popup.arrPrePopup.forEach((popup) => {
            popup.is(':visible') && popup.data('ui').close();
        })
    }

    /**
     * 팝업은 열림과 닫힘으로 이루어져 있고 요소에서 강제 제거시 정상작동이 안된다. 아래는 팝업요소와 html을 비교하여 교정하는 역할을 한다.
     */
    static cleanPopupStack(){
        Popup.arrPrePopup = Popup.arrPrePopup.filter((popup) => {
            const componentId = $(popup).data('id');

            return !!$(`[data-id=${componentId}]`)[0];
        });

        Popup.arrPopup = [...Popup.arrPrePopup];
    }

    /**
     * 팝업 z-index 초기화.
     */
    static cleanPopupZindex(){
        Popup.zIndex = 150

    }
    
    /**
     * 모든 팝업 style 초기화.
     */
    static resetAllPopup(){
        setTimeout(function(){
            $('.ui-popup').each((idx,popup) => {
                $(popup).removeAttr('style')
            })
            $('.popup-wrap .dimm').removeAttr('style')
            Popup.zIndex = 150
        },100)
    }
}

export default Popup;
